import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import purpleButton from "../purpleButton/purpleButton.vue";
import LoadingProgressBar from "@/components/progressBar/loadingProgressBar.vue";
import MyReportButton from "@/components/myReportButton/myReportButton.vue";
import GeneralUtilsHelper from "@/utils/generalUtils";

var VipMask =
/*#__PURE__*/
function (_Vue) {
  _inherits(VipMask, _Vue);

  function VipMask() {
    var _this;

    _classCallCheck(this, VipMask);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VipMask).apply(this, arguments));
    _this.dataIsOk = false;
    _this.buttonStatus = "get";
    return _this;
  }

  _createClass(VipMask, [{
    key: "clickBotton",
    value: function clickBotton() {}
  }, {
    key: "listenStatus",
    value: function () {
      var _listenStatus = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.buttonStatus = this.button_status;

                if (!(this.buttonStatus === "loading")) {
                  _context.next = 17;
                  break;
                }

                console.log("requestResult", this.requestResult);

                if (!this.requestResult) {
                  _context.next = 16;
                  break;
                }

                _context.prev = 4;
                _context.next = 7;
                return this.requestResult();

              case 7:
                result = _context.sent;
                result ? this.dataIsOk = true : this.buttonStatus = "retry";
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](4);
                this.buttonStatus = "retry";

              case 14:
                _context.next = 17;
                break;

              case 16:
                this.dataIsOk = true;

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 11]]);
      }));

      function listenStatus() {
        return _listenStatus.apply(this, arguments);
      }

      return listenStatus;
    }()
  }, {
    key: "endLoading",
    value: function endLoading() {
      this.updateResultByName({
        name: "maskShow",
        result: false
      });
      this.$emit("endLoading");
    }
  }, {
    key: "clickRateUs",
    value: function clickRateUs() {
      this.rateUsFn ? this.rateUsFn() : void 0;
    }
  }, {
    key: "do_retry",
    value: function () {
      var _do_retry = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.buttonStatus = "loading";
                _context2.prev = 1;
                _context2.next = 4;
                return this.requestResult();

              case 4:
                result = _context2.sent;
                result && (this.dataIsOk = true);
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                this.button_status = "retry";

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8]]);
      }));

      function do_retry() {
        return _do_retry.apply(this, arguments);
      }

      return do_retry;
    }()
  }, {
    key: "retryButtonShow",
    get: function get() {
      return this.button_status !== "loading" && this.button_status !== "get";
    }
  }, {
    key: "loadingButtonShow",
    get: function get() {
      return this.button_status === "loading";
    }
  }, {
    key: "isVip",
    get: function get() {
      return GeneralUtilsHelper.isVip();
    }
  }, {
    key: "rateUsShowType",
    get: function get() {
      return this.settingData && this.settingData.client.rate_us && this.settingData.client.rate_us.rate_us_show && this.settingData.client.rate_us.rate_us_show.show_type;
    }
  }, {
    key: "rateUsForce",
    get: function get() {
      return this.settingData && this.settingData.client.rate_us && this.settingData.client.rate_us.rate_us_show && this.settingData.client.rate_us.rate_us_show.show_type === "force";
    }
  }, {
    key: "rateUsVipCloseCount",
    get: function get() {
      return this.settingData && this.settingData.client.rate_us && this.settingData.client.rate_us.rate_us_show && this.settingData.client.rate_us.rate_us_show.vip_close_count;
    }
  }, {
    key: "rateUsSwitch",
    get: function get() {
      return this.settingData && this.settingData.client.rate_us && this.settingData.client.rate_us.rate_us_show && this.settingData.client.rate_us.rate_us_show.switch;
    }
  }, {
    key: "rateUsButtonShow",
    get: function get() {
      // return !this.isVip && this.vipCloseCount >= 3 && !this.rateUsStatus;
      return !this.isVip && this.rateUsSwitch && !this.rateUsStatus && this.vipCloseCount >= this.rateUsVipCloseCount;
    }
  }, {
    key: "getResultLang",
    get: function get() {
      return this.$t("common.button.get_my_relust");
    }
  }]);

  return VipMask;
}(Vue);

tslib_1.__decorate([Prop({
  default: 0
})], VipMask.prototype, "top", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], VipMask.prototype, "type", void 0);

tslib_1.__decorate([Prop({
  default: "72"
})], VipMask.prototype, "marginTop", void 0);

tslib_1.__decorate([Prop({
  default: false
})], VipMask.prototype, "backGround", void 0);

tslib_1.__decorate([Prop({
  default: "get"
})], VipMask.prototype, "button_status", void 0);

tslib_1.__decorate([Prop({
  default: null
})], VipMask.prototype, "requestResult", void 0);

tslib_1.__decorate([Prop({
  default: null
})], VipMask.prototype, "rateUsFn", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_RESULT_BY_NAME)], VipMask.prototype, "updateResultByName", void 0);

tslib_1.__decorate([Getter(types.GETTER_VIP_CLOSE_COUNT)], VipMask.prototype, "vipCloseCount", void 0);

tslib_1.__decorate([Getter(types.GETTER_RATE_US_STATUS)], VipMask.prototype, "rateUsStatus", void 0);

tslib_1.__decorate([Getter(types.GETTER_SETTING_DATA)], VipMask.prototype, "settingData", void 0);

tslib_1.__decorate([Emit("clickBotton")], VipMask.prototype, "clickBotton", null);

tslib_1.__decorate([Watch("button_status", {
  immediate: true
})], VipMask.prototype, "listenStatus", null);

VipMask = tslib_1.__decorate([Component({
  components: {
    purpleButton: purpleButton,
    MyReportButton: MyReportButton,
    LoadingProgressBar: LoadingProgressBar
  }
})], VipMask);
export default VipMask;